export const MIN_TIER_BANDS = 6

export const MAX_TIER_BANDS = 10

export type TierBandErrorCode = 'integer' | 'zeroStart' | 'ascending'

export type TierBandErrors = Partial<Record<number, TierBandErrorCode>>

export function bandsToValues(bands: number[]): string[] {
  return bands.map((b) => String(b))
}

export function valuesToBands(values: string[]): number[] {
  return values.map((v) => Number(v))
}

export function validateTierBandValues(values: string[]): TierBandErrors {
  const errors: TierBandErrors = {}
  const numbers = values.map((v) => (v.trim() === '' ? NaN : Number(v)))
  numbers.forEach((n, i) => {
    if (!Number.isInteger(n) || n < 0) {
      errors[i] = 'integer'
    }
  })
  if (errors[0] === undefined && numbers[0] !== 0) {
    errors[0] = 'zeroStart'
  }
  for (let i = 1; i < values.length; i += 1) {
    if (errors[i] === undefined && errors[i - 1] === undefined && numbers[i] <= numbers[i - 1]) {
      errors[i] = 'ascending'
    }
  }
  return errors
}
